import {PdsWidget} from './pds-widget';
import {CalendarDay} from './interfaces/calendar-day';
import {pdsUtils} from './pds-utils';
import {pdsI18n} from './pds-i18n';
export class PdsDateWidgetDialog extends PdsWidget {

  is = 'pds-date-picker-dialog';

  name: string;
  monthLabels: Array<{value: string, text: string}>;
  pds: any;
  dayLabels: Array<string>;
  todayTimeStamp: number;
  dataMaxdate: string;
  maxDateTimeStamp: number;
  dataMindate: string;
  minDateTimeStamp: number;
  value: Date;

  //One object per day in the current month.
  days: Array<CalendarDay>;

  month: string;
  year: string;

  datePickerDialog: HTMLElement;
  datePickerFocusTrap: (event: KeyboardEvent) => void;
  holdRefresh = false;
  possibleYears: Array<{value: string, text: string}>;

  //TODO search the code to see if this is actually being used.
  yearIncrement: boolean;

  // when the date-picker dialog closes, we want the focus to return to a specific part of the app
  // that is decided by the implementing develop to supply a valid selector
  // by using the data-return-focus attribute

  dataReturnFocus: string;

  properties = {
    name: {
      type: String,
      value: 'pds-date-picker-dialog'
    },
    month: {
      type: String,
      observer: 'monthChange'
    },
    year: {
      type: String,  //TODO update the rest of the page to use strings for year and month.
      observer: 'yearChange'
    },
    possibleYears: {
      type: Array
    },
    dataMaxdate: {
      type: String
    },
    dataMindate: {
      type: String
    },
    //Option to activate the validation indicator
    dataUseValidIndicator: {
      type: String,
      value: 'false'
    },
    dataReturnFocus: {
      type: String,
      value: ''
    }
  };

  setMonthLabels(): void {
    //when created, we need to generate the days to iterate over.
    let monthLabels: Array<{value: string, text: string}> = [];
    pdsI18n.locale.DATETIME_FORMATS.SHORTMONTH.forEach((month, index) => {
      let textValueObj = {
        value: String(index),
        text: month
      };
      monthLabels.push(textValueObj);
    });
    this.monthLabels = monthLabels;
  }

  ready(): void {
    super.ready();

    this.setMonthLabels();

    this.dayLabels = pdsI18n.locale.DATETIME_FORMATS.SHORTDAY;

    let today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    this.todayTimeStamp = today.getTime();

    if (this.dataMaxdate != null) {
      this.maxDateTimeStamp = (new Date(this.dataMaxdate)).getTime();
    }
    if (this.dataMindate != null) {
      this.minDateTimeStamp = (new Date(this.dataMindate)).getTime();
    }

    let d;
    if (this.value != null) {
      d = this.value;
    } else {
      d = today;
    }

    this.holdRefresh = true;
    this.month = String(d.getMonth());
    this.holdRefresh = false;
    this.year = String(d.getFullYear());
    this.name = pdsUtils.getUniqueId(this.name);
  }

  attached(): void {
    super.attached();
    this.handleFocus();
  }

  // Handle the focus of the date picker dialog

  handleFocus(): void {
    let escKey = this.escKey;
    let tabKey = this.tabKey;
    this.datePickerDialog = <HTMLElement>this.querySelector('.date-picker-dialog');
    let firstElement = <HTMLElement>this.querySelector('#date-picker-close');
    if (this.datePickerDialog != null && firstElement != null) {
      firstElement.focus();
      this.datePickerFocusTrap = (event: KeyboardEvent) => {
        let lastElement = this.getLastDayNumElement(this.datePickerDialog);
        if (event.keyCode === escKey) {
          this.closeDialog();
        } else if (event.keyCode === tabKey) {
          if (!event.shiftKey && (event.target === lastElement)) {
            firstElement.focus();
            event.preventDefault();
          } else if (event.shiftKey && (event.target === firstElement)) {
            lastElement.focus();
            event.preventDefault();
          }
        }
      };
      this.datePickerDialog.addEventListener('keydown', this.datePickerFocusTrap);
    }
  }

  /**
   * gets the last element that illustrates the last day of the month...
   * the missing spaces for the days that signify
   * the previous and the next month have a classList attribute of pds-is-invisible.
   * @param datePickerDialog
   */

  getLastDayNumElement(datePickerDialog: HTMLElement): HTMLElement {
    let allButtons = datePickerDialog.querySelectorAll('button');
    let eachDayElement: Array<HTMLElement> = new Array<HTMLElement>();
    Array.prototype.forEach.call((allButtons) , (eachButton: HTMLElement) => {
      if (!eachButton.classList.contains('pds-is-invisible')) {
        eachDayElement.push(eachButton);
      }
    });
    return <HTMLElement>eachDayElement[eachDayElement.length - 1];
  }

  closeDialog(event?: any): void {
    //The value changed. Fire a valueChange event.
    let e = new Event('pds-remove-dialog');
    (<any>this).dispatchEvent(e);
  }

  /**
   * Polymer hook, clean up code for when the dialog closes.
   */

  detached(): void {
    super.detached();
    if (this.dataReturnFocus != null && this.dataReturnFocus.trim().length !== 0) {
      let returnFocusElement = <HTMLElement>document.querySelector(this.dataReturnFocus);
      if (returnFocusElement != null) {
        returnFocusElement.focus();
      }
    }
    if (this.datePickerDialog != null) {
      this.datePickerDialog.removeEventListener('keydown', this.datePickerFocusTrap);
    }
    delete this.datePickerDialog;
  }

  //0-11 for index
  getSelectedMonth(index: number): boolean {
    return String(index) === this.month;
  }

  getSelectedYear(yearValue): boolean {
    return String(yearValue) === String(this.year);
  }

  getSelectedDateClass(dateTimeStamp, value): string | undefined {
    if (value != null && value.getTime() === dateTimeStamp) {
      return 'pds-selected-day';
    }
  }

  getTodayClass(dateTimeStamp): string | undefined {
    if (dateTimeStamp != null && dateTimeStamp === this.todayTimeStamp) {
      return 'pds-date-picker-today';
    }
  }

  getIsWeekendClass(isWeekend): string | undefined {
    if (isWeekend === true) {
      return 'pds-weekend-day';
    }
  }

  getDisabledItemClass(dateTimeStamp: number | null | undefined): string | undefined {
    if (this.isTimeStampDisabled(dateTimeStamp)) {
      return 'pds-disabled-day';
    }
  }

  isTimeStampDisabled(dateTimeStamp: number | null | undefined): boolean {
    if (dateTimeStamp != null) {
      if (this.maxDateTimeStamp != null && this.maxDateTimeStamp < dateTimeStamp) {
        return true;
      }

      if (this.minDateTimeStamp != null && this.minDateTimeStamp > dateTimeStamp) {
        return true;
      }
    }

    return false;
  }

  selectDate(event): void {
    let dateTimeAttr = this.extractAttribute(event, 'button', 'data-date-time');
    if (dateTimeAttr == null) {
      return;
    }

    let dateTimeStamp = new Date(parseInt(dateTimeAttr));

    if (this.isTimeStampDisabled(dateTimeStamp.getTime())) {
      return;
    }

    this.value = dateTimeStamp;

    //The value changed. Fire a valueChange event.
    let e = new Event('pds-date-change-event');
    (<any>this).dispatchEvent(e);
  }

  monthChange(): void {
    if (this.month != null && this.holdRefresh !== true) {
      this.updateDays();
    }
  }

  yearChange(): void {
    this.updateAvailableYears(this.year);
    this.updateDays();
  }

  updateAvailableYears(year): void {
    let newYears: Array<{value: string, text: string}> = [];
    for (let i = 0; i < 21; i++) {
      let val: string = String(year - 10 + i);
      newYears.push({value: val, text: val});
    }
    this.possibleYears = newYears;
  }

  previousMonth(): void {
    if (this.month === '0') {
      this.holdRefresh = true;
      this.month = '11';
      this.holdRefresh = false;
      this.year = String(parseInt(this.year) - 1);
    } else {
      this.month = String(parseInt(this.month) - 1);
    }
  }

  nextMonth(): void {
    if (this.month === '11') {
      this.holdRefresh = true;
      this.month = '0';
      this.holdRefresh = false;
      this.yearIncrement = true;
      this.year = String(parseInt(this.year) + 1);
      this.yearIncrement = false;
    } else {
      this.month = String(parseInt(this.month) + 1);
    }
  }

  setDate(dateTimeString): void {
    this.value = new Date(dateTimeString);
    this.updateDays();
  }

  updateDays(): void {
    let days = this.pds.utils.generateDays(parseInt(this.year), parseInt(this.month));
    // since the dayNum property is undefined...
    // polymer doesnt like passing in undefined as an additional parameter
    // so we have to iterate over the available days, and if the attribute doesnt exist
    // we set it to null
    // https://github.com/Polymer/polymer/issues/2158
    days.forEach((calendarDay) => {
      if (!calendarDay.hasOwnProperty('dayNum')) {
        calendarDay.dayNum = null;
      }
    });
    this.days = days;
  }

  dashCaseToSr(dateAsString: string | undefined, arg: string): string | undefined {
    if (dateAsString) {
      let date = pdsI18n.formatDate(new Date(dateAsString.replace(/-/g, '/')), arg);
      if (date) {
       return date;
      }
    }
    return;
  }

  messageKeysUpdated(): void {
    this.dayLabels = pdsI18n.locale.DATETIME_FORMATS.SHORTDAY;
    this.setMonthLabels();
    super.messageKeysUpdated();
  }
}
